import api from './api';

export interface ContactInquiry {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
  message: string;
  status: 'new' | 'read' | 'replied';
  email_sent: boolean;
  created_at: string;
  updated_at: string;
}

export interface GetContactsParams {
  page?: number;
  limit?: number;
  status?: string;
}

const contactService = {
  getContacts: async (params: GetContactsParams = {}) => {
    const response = await api.get('/contact', { params });
    return response.data;
  },

  updateStatus: async (id: string, status: ContactInquiry['status']) => {
    const response = await api.patch(`/contact/${id}/status`, { status });
    return response.data;
  },
};

export default contactService;
